import axios from "axios";

const base = `${process.env.REACT_APP_BACKEND_URL}/apprenticeship`;
const token = () => localStorage.getItem("token");
const headers = () => ({ headers: { Authorization: "Bearer " + token() } });

export const getMeta = () => axios.get(`${base}/meta`, headers());
export const listApprentices = () => axios.get(`${base}/apprentices`, headers());
export const getApprentice = id => axios.get(`${base}/apprentices/${id}`, headers());
export const createApprentice = body => axios.post(`${base}/apprentices`, body, headers());
export const updateApprentice = (id, body) =>
  axios.put(`${base}/apprentices/${id}`, body, headers());
export const deleteApprentice = id => axios.delete(`${base}/apprentices/${id}`, headers());
export const openWeek = (id, weekStart) =>
  axios.post(`${base}/apprentices/${id}/reports`, { weekStart }, headers());

export const getReport = id => axios.get(`${base}/reports/${id}`, headers());
export const saveReport = (id, body) => axios.put(`${base}/reports/${id}`, body, headers());
export const prefillReport = id => axios.post(`${base}/reports/${id}/prefill`, {}, headers());
export const submitReport = (id, body) =>
  axios.post(`${base}/reports/${id}/submit`, body, headers());
export const commentReport = (id, text) =>
  axios.post(`${base}/reports/${id}/comment`, { text }, headers());
export const returnReport = (id, text) =>
  axios.post(`${base}/reports/${id}/return`, { text }, headers());
export const signReport = (id, body) => axios.post(`${base}/reports/${id}/sign`, body, headers());

// Links that open in a new tab cannot send a header: the token goes in the query.
const tokenQuery = () => `token=${encodeURIComponent(token() || "")}`;
export const reportPdfUrl = id => `${base}/reports/${id}/pdf?${tokenQuery()}`;
export const periodPdfUrl = (id, from, to) =>
  `${base}/apprentices/${id}/pdf?${tokenQuery()}&from=${from || ""}&to=${to || ""}`;
